export const DisclaimerCheckout: string[] = [
  "The cost of Visa, MasterCard, Maestro, DinersClub, UnionPay and JCB is deducted from the payout you receive.",
  "Payment of redeemed credit card transactions takes place in your local currency as soon as the credit card transaction is completed",
  "Acquiring prices stated in contract cover both purchase and refund transactions",
];
